angular.module('unica_grand_prix.grand_prix_controllers')

.controller('GrandPrixViewZmController',
	function(
		$rootScope, $scope, $stateParams,
		GrandPrixRankingEditService,
		$confirm
	) {

	$scope.showPremioGP2021 = false;

	$rootScope.getRankingByID($stateParams.id);

	// console.log('test');

	$scope.$on( 'ranking_loaded', function() {
		console.log($rootScope.rankingData);
		$scope.showPremioGP2021 = [
			45,
			196,
			197,
			198,
		].includes( $rootScope.rankingData.event_id );
	});


	$scope.confirmPreInvitation = function( id ) {

		var confirmText = 'Confermi l\'invitato?';
		var msgSuccessText = 'Invito approvato con successo!';

		if ( $scope.showPremioGP2021 ) {
			confirmText = 'Confermi il premiato?';
			msgSuccessText = 'Premio approvato con successo!';
		}

		$confirm({
			title: 'Sei sicuro di voler confermare?',
			text: confirmText
		}).then(function() {

			$scope.showLoader();

			GrandPrixRankingEditService
				.confirmPreInvitation( id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$rootScope.getRankingByID($stateParams.id);

						$scope.showSuccessMsg(msgSuccessText, '');
					}
				});

		}, function() {
			// Cancel
		});

	};


	$scope.rejectPreInvitation = function( id ) {

		var confirmText = 'Rifiuti l\'invitato?'
		var msgSuccessText = 'Invito rifiutato con successo!';

		if ( $scope.showPremioGP2021 ) {
			confirmText = 'Rifiuti il premiato?';
			msgSuccessText = 'Premio rifiutato con successo!';
		}

		$confirm({
			title: 'Sei sicuro di voler rifiutare?',
			text: confirmText
		}).then(function() {

			$scope.showLoader();

			GrandPrixRankingEditService
				.rejectPreInvitation( id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$rootScope.getRankingByID($stateParams.id);

						$scope.showSuccessMsg( msgSuccessText, '');
					}
				});

		}, function() {
			// Cancel
		});

	};



});